var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef } from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import { KeyboardArrowDown } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { Divider, IconButton, Popover, Typography } from '@mui/material';
import { nanoid } from 'nanoid';
import { isFalsy } from '../../../utils/common';
import { typography } from '../theme';
import Checkbox from './Checkbox';
import TextInput from './TextInput';
var GroupCheckboxWithPopover = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var _l = _a.defaultOptionsSize, defaultOptionsSize = _l === void 0 ? 5 : _l, options = _a.options, restCheckboxProps = __rest(_a, ["defaultOptionsSize", "options"]);
    var _m = __read(React.useState(null), 2), anchorEl = _m[0], setAnchorEl = _m[1];
    var labelRef = useRef(null);
    var handleClick = function () {
        setAnchorEl(labelRef === null || labelRef === void 0 ? void 0 : labelRef.current);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var CustomHeader = function (_a) {
        var _b;
        var onChange = _a.onChange, headerLabelList = _a.headerLabelList, naviagateToHeader = _a.naviagateToHeader;
        var handleHighlight = function (headerLabel) {
            if (isFalsy(headerLabel))
                return;
            var optionsOfHeader = document.querySelectorAll('.GroupedCheckboxOption');
            var otherGroupOptions = Array.from(optionsOfHeader).filter(function (element) {
                return !element.classList.contains("OptionOfGroup-".concat(headerLabel));
            });
            otherGroupOptions.forEach(function (optionElement) {
                optionElement.classList.remove('lfc-opacity-100');
                optionElement.classList.add('lfc-opacity-20');
            });
        };
        var removeHighLight = function () {
            var options = document.querySelectorAll('.GroupedCheckboxOption');
            Array.from(options).forEach(function (optionElement) {
                optionElement.classList.add('lfc-opacity-100');
                optionElement.classList.remove('lfc-opacity-20');
            });
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "lfc-flex   lfc-items-center lfc-justify-between lfc-mb-4 " },
                React.createElement(TextInput, __assign({}, restCheckboxProps === null || restCheckboxProps === void 0 ? void 0 : restCheckboxProps.searchTextFieldProps, { type: "text", sx: __assign({ width: '250px !important' }, (_b = restCheckboxProps === null || restCheckboxProps === void 0 ? void 0 : restCheckboxProps.searchTextFieldProps) === null || _b === void 0 ? void 0 : _b.sx), onChange: onChange })),
                Array.isArray(headerLabelList) && (headerLabelList === null || headerLabelList === void 0 ? void 0 : headerLabelList.length) > 0 && (React.createElement("div", { className: "lfc-flex lfc-justify-around lfc-gap-2 lfc-mx-4" }, headerLabelList.map(function (headerLabel) { return (React.createElement("div", { key: nanoid(), onClick: function () { return naviagateToHeader === null || naviagateToHeader === void 0 ? void 0 : naviagateToHeader(headerLabel); } },
                    React.createElement(Typography, { className: 'lfc-text-gray-500 hover:lfc-text-black lfc-cursor-pointer ', variant: "caption1", fontWeight: 700, onMouseMove: function () {
                            handleHighlight(headerLabel);
                        }, onMouseLeave: removeHighLight }, headerLabel))); }))),
                React.createElement(IconButton, { onClick: handleClose },
                    React.createElement(CloseIcon, { className: "lfc-text-black", fontSize: "small" }))),
            React.createElement(Divider, null)));
    };
    var open = Boolean(anchorEl);
    var id = open ? 'group-checkbox-with-pop-over' : undefined;
    var valuesValues = Array.isArray(restCheckboxProps === null || restCheckboxProps === void 0 ? void 0 : restCheckboxProps.value) && !isFalsy(restCheckboxProps === null || restCheckboxProps === void 0 ? void 0 : restCheckboxProps.value)
        ? (_b = restCheckboxProps === null || restCheckboxProps === void 0 ? void 0 : restCheckboxProps.value) === null || _b === void 0 ? void 0 : _b.map(function (value) { return value === null || value === void 0 ? void 0 : value.value; })
        : null;
    var sortedOptions = (restCheckboxProps === null || restCheckboxProps === void 0 ? void 0 : restCheckboxProps.sortSelected) && valuesValues
        ? (options !== null && options !== void 0 ? options : []).sort(function (a, b) {
            return valuesValues.indexOf(b === null || b === void 0 ? void 0 : b.value) - valuesValues.indexOf(a === null || a === void 0 ? void 0 : a.value);
        })
        : options !== null && options !== void 0 ? options : [];
    return (React.createElement("div", null,
        React.createElement(Checkbox, __assign({}, restCheckboxProps, { label: React.createElement("div", { ref: labelRef }, restCheckboxProps === null || restCheckboxProps === void 0 ? void 0 : restCheckboxProps.label), formGroupProps: { 'aria-describedby': id }, options: sortedOptions === null || sortedOptions === void 0 ? void 0 : sortedOptions.slice(0, defaultOptionsSize) })),
        ((_c = sortedOptions === null || sortedOptions === void 0 ? void 0 : sortedOptions.length) !== null && _c !== void 0 ? _c : 0) > defaultOptionsSize && (React.createElement("div", { onClick: handleClick, className: "lfc-w-fit" },
            React.createElement(GBTypography, { variant: "link2", className: "lfc-text-primary-500 hover:lfc-underline lfc-cursor-pointer" },
                React.createElement("span", null,
                    React.createElement(KeyboardArrowDown, { fontSize: "small" })),
                "View all"))),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            } },
            React.createElement("div", { className: "lfc-bg-white lfc-border lfc-border-primary-400 lfc-p-4 lfc-rounded-md lfc-w-fit" },
                React.createElement(Checkbox, __assign({ groupOptions: true, renderCustomHeader: CustomHeader }, restCheckboxProps, { options: sortedOptions, formGroupProps: __assign(__assign({}, restCheckboxProps === null || restCheckboxProps === void 0 ? void 0 : restCheckboxProps.formGroupProps), { sx: __assign({ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', height: '350px', padding: '12px' }, (_d = restCheckboxProps === null || restCheckboxProps === void 0 ? void 0 : restCheckboxProps.formGroupProps) === null || _d === void 0 ? void 0 : _d.sx) }), searchable: true, formGroupContainerClassNames: "lfc-flex lfc-flex-col lfc-gap-[2px] lfc-max-w-[800px] lfc-overflow-x-auto ".concat((_e = restCheckboxProps === null || restCheckboxProps === void 0 ? void 0 : restCheckboxProps.formGroupContainerClassNames) !== null && _e !== void 0 ? _e : ''), searchAndOptionsContainerClassNames: "lfc-flex lfc-flex-col lfc-w-fit ".concat((_f = restCheckboxProps === null || restCheckboxProps === void 0 ? void 0 : restCheckboxProps.searchAndOptionsContainerClassNames) !== null && _f !== void 0 ? _f : ''), formControlLabelProps: __assign({ componentsProps: {
                            typography: {
                                sx: {
                                    fontWeight: "".concat((_g = typography.body2) === null || _g === void 0 ? void 0 : _g.fontWeight, " !important"),
                                    fontSize: "".concat((_h = typography.body2) === null || _h === void 0 ? void 0 : _h.fontSize, " !important"),
                                    lineHeight: "".concat((_j = typography.body2) === null || _j === void 0 ? void 0 : _j.lineHeight, " !important"),
                                    maxWidth: '220px'
                                }
                            }
                        } }, (_k = restCheckboxProps === null || restCheckboxProps === void 0 ? void 0 : restCheckboxProps.formControlLabelProps) === null || _k === void 0 ? void 0 : _k.componentsProps) }))))));
};
export default GroupCheckboxWithPopover;
//# sourceMappingURL=GroupCheckboxWithPopover.js.map